import type {
	QuizTestAnswerData,
	QuizTestData,
} from "@ext/enterprise/components/admin/settings/quiz/types/QuizComponentTypes";
import type { StoredAnswer } from "@ext/markdown/elements/answer/types";
import type { QuestionType } from "@ext/markdown/elements/question/types";

type QuizTestQuestion = QuizTestData["questions"][number];

export type RawQuizTestData = {
	answers: { answersIds: StoredAnswer | string[]; questionId: string }[];
	questions: (Omit<QuizTestQuestion, "type"> & { type?: QuestionType })[];
};

const toStoredAnswer = (answersIds: StoredAnswer | string[]): StoredAnswer =>
	Array.isArray(answersIds) ? Object.fromEntries(answersIds.map((id) => [id, true])) : answersIds;

const inferQuestionType = (answers: QuizTestAnswerData[]): QuestionType =>
	answers.filter((answer) => answer.correct).length > 1 ? "many" : "one";

export const normalizeQuizTestData = ({ answers, questions }: RawQuizTestData): QuizTestData => ({
	answers: answers?.map(({ questionId, answersIds }) => ({ questionId, answersIds: toStoredAnswer(answersIds) })),
	questions: questions?.map((question) => ({
		...question,
		type: question.type ?? inferQuestionType(question.answers),
	})),
});
